<sc-modal class="payment-methods-modal" #modal [closeButton]="false">
	<div class="modal__container" *ngIf="!loading">
		<div class="title"><sc-title content="Tarifas y formas de pago" type="h3"></sc-title></div>
		<form [formGroup]="formGroup">
			<div class="modal__comercial-alternative" *ngIf="!hideCommercialDiscount && commercialDiscounts">
				<sc-select
					formControlName="commercialDiscount"
					label="Alternativa comercial"
					objectValue="name"
					[items]="commercialDiscounts"
					[hideError]="true"
					[isDisabled]="partialLoading"
					(optionSelected)="handlePremiumDiscountSelect($event)"
				></sc-select>
				<div class="under-writing-indicator" *ngIf="premiumDiscountLimit && hasUnderWritingFlag">
					<sc-info-box icon="alert-elipse-copy" class="under-writing">
						{{ underWritingMessage }}
					</sc-info-box>
				</div>
			</div>
			<div class="modal__fees">
				<sc-select
					formControlName="paymentFee"
					label="Cuotas"
					[items]="feeOptions"
					[isDisabled]="partialLoading"
					[hideError]="true"
					(optionSelected)="handleRecalculate()"
				></sc-select>
			</div>
			<div class="modal__payment-method-selection">
				<span>Formas de pago</span>
				<div class="payment-method-selection">
					<sc-radio-group formControlName="paymentTypeId" [isReadOnly]="partialLoading">
						<div class="payment-method-selection__item" *ngFor="let method of internalPaymentMethods">
							<sc-radio-item [value]="method.paymentTypeId" (check)="handlePaymentMethodSelected(method)">
								<span class="payment-method-selection__item-text">{{ method.title }}</span>
							</sc-radio-item>
							<span class="total-cost" *ngIf="!method.loading && method.finalAmount && !method.hideAmount">
								{{ (method.finalAmount / formGroup.get('paymentFee').value.key) | scCurrency }}
							</span>
							<sc-button 
								*ngIf="!method.loading && !method.finalAmount && !method.hideAmount" 
								type="link" 
								[disabled]="partialLoading"
								(onClick)="handleRecalculate(method)">
								Calcular
							</sc-button>
							<sc-icon icon="loading" *ngIf="method.loading"></sc-icon>
						</div>
					</sc-radio-group>
				</div>
			</div>
			<div class="modal__submit-block">
				<sc-button (onClick)="handleApplyChanges()" [disabled]="formGroup.invalid || partialLoading" id="payment-method-modal-aplicar">Aplicar</sc-button>
				<sc-button (onClick)="handleCancelChanges()" type="secondary" [disabled]="formGroup.invalid || partialLoading" id="payment-method-modal-cancelar">Cancelar</sc-button>
			</div>
		</form>
	</div>
	<div *ngIf="loading">
		<sc-icon icon="loading"></sc-icon>
	</div>
</sc-modal>
